import React from 'react';
import PropTypes from 'prop-types';
import AutoSuggester from 'react-autosuggest';

import Input from 'src/app/components/Input';
import FormControl from 'src/app/components/FormControl/FormControl';
import theme from 'src/app/components/AutoSuggesterInput.scss';


class AutoSuggesterInput extends React.Component {

  renderInput = (inputProps) => {
    const {
      value,
      validationMessage,
      focus,
      markedAsWrong,
      apiError,
      label,
      inputRef,
      disabled,
      required,
      pattern,
      maxLength,
      dataTest
    } = this.props;

    return (
      <FormControl value={ value }
                   validationMessage={ validationMessage }
                   markedAsWrong={ markedAsWrong }
                   focus={ focus }
                   apiError={ apiError }
                   label={ label }
                   disabled={ disabled }
      >
        <Input { ...{ ...inputProps, pattern, required, maxLength } } ref={ inputRef } autoComplete="turn-off"
               data-test={ dataTest }/>
      </FormControl>
    );
  };

  render() {
    const { renderInput } = this;
    const {
      id,
      suggestions,
      onSuggestionSelected,
      value,
      onChange,
      onBlur,
      onFocus,
      getSuggestions,
      clearSuggestions,
      renderSuggestion,
      getSuggestionValue
    } = this.props;

    return (
      <AutoSuggester id={ id }
                     suggestions={ suggestions }
                     onSuggestionsFetchRequested={ getSuggestions }
                     onSuggestionsClearRequested={ clearSuggestions }
                     renderSuggestion={ renderSuggestion }
                     getSuggestionValue={ getSuggestionValue }
                     onSuggestionSelected={ onSuggestionSelected }
                     theme={ theme }
                     inputProps={ { onChange, onBlur, onFocus, value } }
                     renderInputComponent={ (inputProps) => renderInput(inputProps) }
                     focusInputOnSuggestionClick={ false }
      />
    );
  }
}


AutoSuggesterInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
    ])).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  getSuggestions: PropTypes.func.isRequired,
  validationMessage: PropTypes.string.isRequired,
  markedAsWrong: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  apiError: PropTypes.bool.isRequired,
  renderSuggestion: PropTypes.func.isRequired,
  dataTest: PropTypes.string.isRequired,
  pattern: PropTypes.string,
  maxLength: PropTypes.string
};

AutoSuggesterInput.defaultProps = {
  pattern: '.*',
  maxLength: ''
};


export default AutoSuggesterInput;
